/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { PersonneGridDto } from './PersonneGridDto';
import {
    PersonneGridDtoFromJSON,
    PersonneGridDtoFromJSONTyped,
    PersonneGridDtoToJSON,
} from './PersonneGridDto';

/**
 * 
 * @export
 * @interface PersonneGridDtoPaginatedResults
 */
export interface PersonneGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof PersonneGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<PersonneGridDto>}
     * @memberof PersonneGridDtoPaginatedResults
     */
    results?: Array<PersonneGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof PersonneGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the PersonneGridDtoPaginatedResults interface.
 */
export function instanceOfPersonneGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PersonneGridDtoPaginatedResultsFromJSON(json: any): PersonneGridDtoPaginatedResults {
    return PersonneGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function PersonneGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonneGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(PersonneGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function PersonneGridDtoPaginatedResultsToJSON(value?: PersonneGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(PersonneGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

